export const VisitsActiveModal = {
    None: 0,
    AddEdit: 1,
    Preview: 2,
    Delete: 3,
    ConfirmBox: 4,
    Info: 5
}



// WEBPACK FOOTER //
// ./src/Models/VisitsActiveModal.js